import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { GET, POST, PUT, DELETE } from '../../services/api';

// Define the async thunk for adding a podcast category
export const addPodcastCategory = createAsyncThunk(
  'data/add/podcastCategory',
  async (data, { rejectWithValue }) => {
    try {
      const response = await POST('/admin/podcast-category', data);
      if (response?.status === 200) {
        return response.data.result;
      } else {
        return rejectWithValue(response?.data || 'Something went wrong');
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data || 'Failed to fetch data');
    }
  }
);

export const viewPodcastCategory = createAsyncThunk(
    "data/view/podcastCategory",
    async (podacstId, { rejectWithValue }) => {
      try {
        const response = await GET(`/admin/podcast-category/view`, { p_category_id: podacstId });
        return response.data;
      } catch (error) {
        return rejectWithValue(error?.response?.data || "An error occurred");
      }
    }
  );


// Define the async thunk for listing podcast categories
export const listPodcastCategory = createAsyncThunk(
  'data/list/podcastCategory',
  async (params={}, { rejectWithValue }) => {
    try {
      const response = await GET('/admin/podcast-category', {...params});
      if (response?.status === 200) {
        return response.data;
      } else {
        return rejectWithValue(response?.data || 'Something went wrong');
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data || 'Failed to fetch data');
    }
  }
);

// Define the async thunk for updating a podcast category
export const updatePodcastCategory = createAsyncThunk(
  'data/update/podcastCategory',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await PUT(`/admin/podcast-category?p_category_id=${id}`, data);
      if (response?.status === 200) {
        return response.data.result;
      } else {
        return rejectWithValue(response?.data || 'Something went wrong');
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data || 'Failed to update data');
    }
  }
);

// Define the async thunk for deleting a podcast category
export const deletePodcastCategory = createAsyncThunk(
  'data/delete/podcastCategory',
  async (id, { rejectWithValue }) => {
    try {
      const response = await DELETE(`/admin/podcast-category`, { p_category_id: id });
      if (response?.status === 200) {
        return response.data.result;
      } else {
        return rejectWithValue(response?.data || 'Something went wrong');
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data || 'Failed to delete data');
    }
  }
);

const PodcastCategorySlice = createSlice({
  name: 'podcastCategory',
  initialState: {
    addPodcastCategory: [],
    addPodcastCategoryLoading: false,
    addPodcastCategoryError: null,
    listPodcastCategorydata: [],
    listPodcastCategoryCount: '',
    listPodcastCategoryLoading: false,
    listPodcastCategoryError: null,
    viewPodcastCategorydata: [],
    viewPodcastCategoryLoading: false,
    viewPodcastCategoryError: null,
    updatePodcastCategory: [],
    updatePodcastCategoryLoading: false,
    updatePodcastCategoryError: null,
    deletePodcastCategory: [],
    deletePodcastCategoryLoading: false,
    deletePodcastCategoryError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addPodcastCategory.pending, (state) => {
        state.addPodcastCategoryLoading = true;
        state.addPodcastCategoryError = null;
      })
      .addCase(addPodcastCategory.fulfilled, (state, action) => {
        state.addPodcastCategoryLoading = false;
        state.addPodcastCategory = action.payload;
      })
      .addCase(addPodcastCategory.rejected, (state, action) => {
        state.addPodcastCategoryLoading = false;
        state.addPodcastCategoryError = action.error.message;
      })

      .addCase(viewPodcastCategory.pending, (state) => {
        state.viewPodcastCategoryLoading = true;
        state.viewPodcastCategoryError = null;
      })
      .addCase(viewPodcastCategory.fulfilled, (state, action) => {
        state.viewPodcastCategoryLoading = false;
        state.viewPodcastCategorydata = action.payload.result;
      })
      .addCase(viewPodcastCategory.rejected, (state, action) => {
        state.viewPodcastCategoryLoading = false;
        state.viewPodcastCategoryError = action.error.message;
      })

      .addCase(listPodcastCategory.pending, (state) => {
        state.listPodcastCategoryLoading = true;
        state.listPodcastCategoryError = null;
      })
      .addCase(listPodcastCategory.fulfilled, (state, action) => {
        state.listPodcastCategoryLoading = false;
        state.listPodcastCategorydata = action.payload?.result?.rows;
        state.listPodcastCategoryCount = action.payload?.result?.count;
      })
      .addCase(listPodcastCategory.rejected, (state, action) => {
        state.listPodcastCategoryLoading = false;
        state.listPodcastCategoryError = action.error.message;
      })
      .addCase(updatePodcastCategory.pending, (state) => {
        state.updatePodcastCategoryLoading = true;
        state.updatePodcastCategoryError = null;
      })
      .addCase(updatePodcastCategory.fulfilled, (state, action) => {
        state.updatePodcastCategoryLoading = false;
        state.updatePodcastCategory = action.payload;
      })
      .addCase(updatePodcastCategory.rejected, (state, action) => {
        state.updatePodcastCategoryLoading = false;
        state.updatePodcastCategoryError = action.error.message;
      })
      .addCase(deletePodcastCategory.pending, (state) => {
        state.deletePodcastCategoryLoading = true;
        state.deletePodcastCategoryError = null;
      })
      .addCase(deletePodcastCategory.fulfilled, (state, action) => {
        state.deletePodcastCategoryLoading = false;
        state.deletePodcastCategory = action.payload;
      })
      .addCase(deletePodcastCategory.rejected, (state, action) => {
        state.deletePodcastCategoryLoading = false;
        state.deletePodcastCategoryError = action.error.message;
      });
  },
});

export default PodcastCategorySlice.reducer;
